<template>
  <div>
    <!-- Modal general-->
    <Modal
      ref="modal"
      :grande="!esUnico && !importando"
      class="modal-detalle-codigos"
    >
      <template slot="cabecera">
        <!-- Si se esta importando -->
        <h5 class="modal-title" v-if="importando">
          Importar
        </h5>
        <!-- Si es detalle -->
        <h5 class="modal-title" v-else>
          Detalle
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </template>
      <template slot="cuerpo">
        <!-- Cuerpo si es importar -->
        <div v-if="importando">
          <!-- Altas masivas -->
          <label for="altasFileInput">Altas </label>
          <input
            @change="obtenerArchivoAlta"
            ref="fileInputAlta"
            class="form-control mb-3"
            type="file"
            id="altasFileInput"
            accept=".csv"
          />
          <button
            @click="clickImportarAltas()"
            type="button"
            class="btn btn-success"
          >
            <blaise-icon icon="GUARDAR" />
            Guardar
          </button>

          <hr />

          <!-- Bajas masivas -->
          <label for="bajasFileInput">Bajas </label>
          <input
            @change="obtenerArchivoBaja"
            ref="fileInputBaja"
            class="form-control mb-3"
            type="file"
            id="bajasFileInput"
            accept=".csv"
          />
          <button
            @click="clickImportarBajas()"
            type="button"
            class="btn btn-success"
          >
            <blaise-icon icon="GUARDAR" />
            Guardar
          </button>
        </div>

        <!-- Cuerpo si es detalle -->
        <div v-else>
          <!-- Cuerpo si es codigo unico -->
          <div v-if="esUnico">
            <div class="form-floating mb-3">
              <!-- Input del codigo unico -->
              <input
                v-model="codigo.codigo"
                type="text"
                class="form-control"
                id="floatingCodigo"
                placeholder="Ej: A1b2F98"
              />
              <label for="floatingCodigo">Código</label>
            </div>
          </div>

          <!-- Cuerpo si es codigo multiple -->
          <div v-else class="container-tabla-codigos">
            <table id="tablaCodigos" class="table table-hover">
              <thead>
                <tr>
                  <th>Acción</th>
                  <th>Código</th>
                  <th>Fecha Inicio</th>
                  <th>Fecha Vencimiento</th>
                  <th>Fue usado</th>
                  <th>DNI Afiliado</th>
                  <th>Compañía de Afiliado</th>
                </tr>
              </thead>

              <!-- Lista de codigos (multiple) -->
              <Codigos
                v-for="codigo in codigoList"
                v-bind:key="codigo.codigo"
                class="fila"
                :valor="codigo"
                v-on:editar="clickEditarCodigo(codigo)"
                v-on:eliminar="clickEliminarCodigo(codigo)"
              />
            </table>
          </div>
        </div>
      </template>
      <template v-slot:pie>
        <button
          :disabled="!codigo.codigo"
          @click="clickGuardarCodigoUnico(codigo)"
          type="button"
          class="btn btn-success"
          v-if="esUnico"
        >
          <blaise-icon icon="GUARDAR" />
          Guardar
        </button>
      </template>
    </Modal>

    <!-- Modal para edicion de codigo-->
    <Modal ref="modalEdicionCodigos">
      <template slot="cabecera">
        <h5 class="modal-title">
          Editar código
        </h5>
        <button
          type="button"
          class="btn-close"
          data-bs-dismiss="modal"
          aria-label="Close"
        ></button>
      </template>
      <template slot="cuerpo">
        <Formulario ref="formulario" class="row" v-if="codigo">
          <div>
            <!--Codigo-->
            <div class="form-floating mb-3">
              <input
                v-model="codigo.codigo"
                type="text"
                class="form-control"
                id="floatingCodigo"
                placeholder="Ej: A1b2F98"
                required
              />
              <label for="floatingCodigo">Código</label>
            </div>
          </div>
          <div class="col-md-6">
            <!--Fecha inicio-->
            <div class="form-floating mb-3">
              <p>Fecha de Inicio</p>
              <DatePicker
                v-model="codigo.fechaInicio"
                format="DD/MM/YYYY"
                value-type="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                :editable="false"
              ></DatePicker>
            </div>
          </div>
          <div class="col-md-6">
            <!--Fecha vencimiento-->
            <div class="form-floating mb-3">
              <p>Fecha de Vencimiento</p>
              <DatePicker
                v-model="codigo.fechaVencimiento"
                format="DD/MM/YYYY"
                valueType="DD/MM/YYYY"
                placeholder="DD/MM/YYYY"
                :editable="false"
                :default-value="new Date()"
                :disabled-date="
                  (date) =>
                    deshabilitarMenorFechaInicio(date, codigo.fechaInicio)
                "
              ></DatePicker>
            </div>
          </div>
        </Formulario>
      </template>
      <template v-slot:pie>
        <button
          @click="clickGuardarCodigo(codigo)"
          type="button"
          class="btn btn-success"
        >
          <blaise-icon icon="GUARDAR" />
          Guardar
        </button>
      </template>
    </Modal>

    <div v-show="!cargando">
      <div
        v-show="cantidad <= 0"
        class="alert alert-primary info-sin-elementos"
        role="alert"
      >
        <p class="principal">No se encontraron beneficios</p>
        <p v-if="infoSinResultados" class="extra">{{ infoSinResultados }}</p>
      </div>
      <div v-show="cantidad > 0" class="table-responsive">
        <table id="tablaBeneficios" class="table table-hover tabla-beneficios">
          <thead>
            <tr>
              <th>Acción</th>
              <th>Comercio</th>
              <th>Localidad</th>
              <th>Nombre</th>
              <th>Descuento Estándar</th>
              <th>Días habilitados</th>
              <th>Medio de pago</th>
            </tr>
          </thead>

          <BeneficioCodigos
            v-for="benef in lista"
            v-bind:key="benef.id"
            class="fila"
            :valor="benef"
            v-on:importar="clickImportar(benef.id)"
            v-on:exportar="clickExportar(benef)"
            v-on:detalle="clickDetalle(benef)"
          />
        </table>
      </div>
      <Paginacion
        ref="paginacion"
        :cantidad="cantidad"
        :cantidadPorPagina="CantidadPorPagina"
        v-on:pagina-cambiada="paginaCambiada"
      />
    </div>
    <div v-show="cargando" class="spinner-border" role="status">
      <span class="sr-only">Cargando...</span>
    </div>
  </div>
</template>

<script>
import BeneficioCodigos from "./util/BeneficioCodigos";
import Codigos from "./util/Codigos";
import Modal from "../modals/Modal.vue";
import Formulario from "../formularios/Formulario.vue";

import { Paginacion as ConstantesPaginacion } from "../../../constants";
import Paginacion from "../../Paginacion";
import { Util } from "../../../util";
import DatePicker from "vue2-datepicker";
import Swal from "sweetalert2";

import { CodigoFacade } from "../../../admin/codigo/codigo.facade";

const CODIGO_LIMPIO = {
  codigo: null,
  dni: null,
  fechaInicio: null,
  fechaVencimiento: null,
  utilizado: false,
  beneficioId: null,
};

export default {
  components: {
    BeneficioCodigos,
    Codigos,
    DatePicker,
    Modal,
    Formulario,
    Paginacion,
  },
  props: {
    busqueda: Object,
    // Si está en verdadero, no se realizarán cargas automáticas
    // Ejemplo en el mounted hook o cuando cambia la búsqueda
    cargaManual: Boolean,
    comercioList: Array,
    /** Utilizada para cargar y guardar datos */
    facade: Function,
    // Información extra mostrada cuando no se encontraron resultados
    infoSinResultados: String,
    // Usado para saber si se ordenará en un futuro
    puedeOrdenar: Boolean,
    tiposCodigoList: Array,
  },
  data() {
    return {
      archivoAlta: null,
      archivoBaja: null,
      beneficioActual: null,
      /** Cantidad en el server */
      cantidad: 0,
      codigosExitosos: null,
      codigosFallidos: null,
      cargando: true,
      codigo: Util.copiaProfunda(CODIGO_LIMPIO),
      codigoList: [],
      editando: false,
      indexFalla: null,
      mensajeFalla: null,
      importando: false,
      esUnico: false,
      lista: [],
      listaIndexMensajesFalla: [],
      orden: {
        // Los teletransportadores son usados para mover items entre paginas
        teletransportadorTop: [],
        teletransportadorBot: [],
      },
      /** Numero de pagina */
      pagina: 1,
    };
  },
  computed: {
    CantidadPorPagina() {
      return ConstantesPaginacion.BENEFICIOS_POR_PAGINA;
    },
    HayPaginaAnterior() {
      return this.pagina > 1;
    },
    HayPaginaSiguiente() {
      return this.pagina * this.CantidadPorPagina < this.cantidad;
    },
  },
  watch: {
    busqueda() {
      if (!this.cargaManual) this.recargar();
    },
  },
  methods: {
    // Los métodos con "Evento" adelante son llamados desde afuera, si se cambia su interface, hay que cambiar afuera
    EventoRecargar(busqueda) {
      this.recargar(busqueda);
    },

    /**
     * Metodo para deshabilitar en date picker de vencimiento los dias menores a fecha inicio
     * @param {*} date
     */
    deshabilitarMenorFechaInicio(date, fecha) {
      // se separa fecha entrante (string) en dia, mes, anio
      const fechaSeparada = fecha.split("/");
      // se crea Date equivalente a fecha entrante (string) para poder hacer la comparacion
      // Date(anio, mes - 1 (0-11), dia)
      const fechaInicioDate = new Date(
        fechaSeparada[2],
        fechaSeparada[1] - 1,
        fechaSeparada[0]
      );
      return date < fechaInicioDate;
    },

    /**
     * click en boton detalle.
     * Si es codigo unico, tiene edicion o creacion de codigo unico
     * Si es codigo multiple, guarda la lista de codigos y el id del beneficio
     * Luego abre el modal     *
     * @param {*} benef es el beneficio actual
     */
    clickDetalle(benef) {
      // Fija si el tipo de codigo es unico, para definir modo detalle
      this.esUnico = benef.tipoCodigo == "UNICO";
      // No esta importando
      this.importando = false;
      // Guarda el unico codigo
      if (this.esUnico) {
        if (benef.codigos[0]) {
          // edicion
          this.editando = true;
          this.codigo = Util.copiaProfunda(benef.codigos[0]);
          this.codigo.beneficioId = benef.id;
        } else {
          // creacion
          this.codigo.id = null;
          this.codigo.beneficioId = benef.id;
          this.codigo.codigo = '';
        }
      }
      // o guarda la lista si es multiple
      else {
        this.codigoList = benef.codigos;
        this.beneficioActual = benef.id;
      }

      this.$refs.modal.abrir();
    },

    /**
     * click en boton exportar.
     * Llama al metodo en facade que llama al endpoint para exportar codigos de un beneficio en particular
     * @param {*} benef es el beneficio actual
     */
    clickExportar(benef) {
      if (benef.codigos && benef.codigos.length) {
        this.facade.getCsvCodigos(benef, benef.comercio.nombre);
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "El beneficio no tiene códigos asociados que exportar.",
        });
      }
    },

    /**
     * click en boton importar.
     * se pone en modo importar, abre el modal de importacion
     */
    clickImportar(benefId) {
      this.importando = true;
      this.beneficioActual = benefId;
      this.$refs.modal.abrir();
    },

    /**
     * click en boton guardar de modal de codigo unico
     * Si es edicion o creacion, llama al metodo correspondiente de facade, cierra el modal y recarga la tabla
     * @param {*} codigo es el codigo actual a guardar
     */
    clickGuardarCodigoUnico(codigo) {
      //Es codigo unico
      if (this.esUnico) {
        if (codigo && this.editando) {
          // Edicion
          CodigoFacade.update(codigo)
            .then(() => {
              this.editando = false;
              this.$refs.modal.cerrar();
              // Recargar tabla principal
              this.recargar();
            })
            // Error al guardar el codigo
            .catch((error) => {
              const data = error.response.data;
              if (data) {
                return Swal.fire({
                  icon: "error",
                  title: "Error",
                  text: "Error al editar el código",
                });
              }
            });
        }

        // Creacion
        else if (codigo && !this.editando) {
          CodigoFacade.create(codigo)
            .then(() => {
              this.$refs.modal.cerrar();
              // Recargar tabla principal
              this.recargar();
            })
            // Error al guardar el codigo
            .catch((error) => {
              const data = error.response.data;
              if (data) {
                return Swal.fire({
                  icon: "error",
                  title: "Error",
                  text: "Error al crear el código",
                });
              }
            });
        }
      }
    },

    /**
     * click a boton editar en algun codigo de modal de codigos multiples para un beneficio
     * se pone en modo edicion, copia el codigo al dto, obtiene el beneficio id y abre el modal de edicion de codigo multiple
     * @param {*} codigo es el codigo actual que se esta editando
     */
    clickEditarCodigo(codigo) {
      this.editando = true;
      this.codigo = Util.copiaProfunda(codigo);
      this.codigo.beneficioId = this.beneficioActual;
      this.$refs.modalEdicionCodigos.abrir();
    },

    /**
     * click a boton guardar en modal de edicion de codigo multiple
     * llama al metodo correspondiente de facade, cierra los dos modales y recarga la tabla
     * @param {*} codigo es el codigo actual que se esta editando
     */
    clickGuardarCodigo(codigo) {
      if (codigo) {
        CodigoFacade.update(codigo)
          .then(() => {
            this.editando = false;
            this.$refs.modal.cerrar();
            this.$refs.modalEdicionCodigos.cerrar();
            // Recargar tabla de codigos
            this.recargar();
          })
          // Error al guardar el codigo
          .catch((error) => {
            const data = error.response.data;
            if (data) {
              return Swal.fire({
                icon: "error",
                title: "Error",
                text: "Error al editar el código",
              });
            }
          });
      }
    },

    /**
     * click a boton eliminar en modal de edicion de codigo multiple
     * usa swal para evitar eliminar de golpe, llama al metodo correspondiente en facade, cierra los modales y recarga la tabla
     * @param {*} codigo
     */
    clickEliminarCodigo(codigo) {
      Swal.fire({
        title: "Atención!",
        text: "¿Está seguro que desea eliminar este código?",
        icon: "warning",
        showCancelButton: true,
        showLoaderOnConfirm: true,
        confirmButtonColor: "#d33",
        cancelButtonColor: "#3085d6",
        confirmButtonText: "Sí, eliminar",
        cancelButtonText: "No",
        preConfirm: () => {
          return CodigoFacade.deleteById(codigo.id)
            .then(() => {
              this.$refs.modal.cerrar();
              this.$refs.modalEdicionCodigos.cerrar();
              // Recargar tabla de codigos
              this.recargar();
            })
            .catch(() => {
              Swal.showValidationMessage(
                "Ocurrió un error al eliminar el código"
              );
            });
        },
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire(
            "Confirmación",
            "El código se ha eliminado con éxito",
            "success"
          );
        }
      });
    },

    /**
     * Obtiene el archivo del input file para altas masivas
     * @param {*} event
     */
    obtenerArchivoAlta(event) {
      this.archivoAlta = event.target.files[0];
    },

    /**
     * Obtiene el archivo del input file para bajas masivas
     * @param {*} event
     */
    obtenerArchivoBaja(event) {
      this.archivoBaja = event.target.files[0];
    },

    /**
     * Forma la data para mandar a la request de altas.
     * Segun el tipo de archivo subido:
     *  -csv: hace la request, guarda los datos, une los mnesajes
     *        usa swal.fire para mostrar la info que trae la request sobre la misma
     *        luego limpia las variables y el input file
     *  -otros tipos: usa swal.fire para mostrar mensaje de tipo invalido, limpia el input file
     */
    clickImportarAltas() {
      if (this.archivoAlta) {
        let postData = new FormData();
        postData.append("file", this.archivoAlta, this.archivoAlta.name);

        // Revisa que el archivo sea csv
        if (this.archivoAlta.type == "text/csv") {
          // Hace la request
          CodigoFacade.uploadFileAlta(this.beneficioActual, postData)
            .then((response) => {
              // Guarda datos
              this.codigosExitosos = response.data.exitos;
              this.codigosFallidos = response.data.fallas;
              this.indexFalla = response.data.indexFalla;
              this.mensajeFalla = response.data.mensajeFalla;

              // Une los mensajes
              this.unirIndicesMensajesFalla(this.indexFalla, this.mensajeFalla);

              // Generar html para mostrar en la tabla de info
              let htmlListaMensajes = this.listaIndexMensajesFalla
                .map(
                  (elem) =>
                    `<tr><th scope="row" class="text-center">${elem.index +
                      2}</th><td>${elem.mensaje}</td></tr>`
                )
                .join("");

              // Abro modal con info
              Swal.fire({
                icon: "info",
                html:
                  `<h5>Códigos procesados exitosamente: ${this.codigosExitosos}</h5>` +
                  `<h5>Códigos no procesados: ${this.codigosFallidos}</h5>` +
                  `<table class="${
                    this.codigosFallidos ? "" : "d-none"
                  } table table-striped table-sm mt-3">
                  <thead>
                    <tr>
                      <th scope="col" class="text-center"># línea en csv</th>
                      <th scope="col">Error encontrado</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${htmlListaMensajes}
                  </tbody>
                </table>`,
                confirmButtonText: "Cerrar",
              })
                // Cuando se clickea en boton cerrar
                .then((result) => {
                  if (result.isConfirmed) {
                    // Se limpian variables
                    this.archivoAlta = null;
                    this.codigosExitosos = null;
                    this.codigosFallidos = null;
                    this.indexFalla = [];
                    this.mensajeFalla = [];
                    this.listaIndexMensajesFalla = [];

                    // Se limpia el input file
                    this.$refs.fileInputAlta.value = null;

                    // Cerrar modal y recargar tabla principal
                    this.$refs.modal.cerrar();
                    this.recargar();
                  }
                });
            })
            // Si ocurre un error en la request
            .catch(() => {
              Swal.fire(
                "Error",
                "Hubo un error al guardar el archivo",
                "error"
              );
            });
        }
        // Si es otro tipo de archivo que no sea csv
        else {
          Swal.fire(
            "Error",
            "Tipo de archivo inválido. Se espera archivo .csv",
            "error"
          )
            // Cuando se presiona en boton de confirmacion se limpia el input
            .then((result) => {
              if (result.isConfirmed) {
                this.$refs.fileInputAlta.value = null;
              }
            });
        }
      }
    },

    /**
     * Forma la data para mandar a la request de bajas.
     * Segun el tipo de archivo subido:
     *  -csv: hace la request, guarda los datos, une los menssajes
     *        usa swal.fire para mostrar la info que trae la request sobre la misma
     *        luego limpia las variables y el input file
     *  -otros tipos: usa swal.fire para mostrar mensaje de tipo invalido, limpia el input file
     */
    clickImportarBajas() {
      if (this.archivoBaja) {
        let postData = new FormData();
        postData.append("file", this.archivoBaja, this.archivoBaja.name);

        // Revisa que el archivo sea csv
        if (this.archivoBaja.type == "text/csv") {
          // Hace la request
          CodigoFacade.uploadFileBaja(this.beneficioActual, postData)
            .then((response) => {
              // Guarda datos
              this.codigosExitosos = response.data.exitos;
              this.codigosFallidos = response.data.fallas;
              this.indexFalla = response.data.indexFalla;
              this.mensajeFalla = response.data.mensajeFalla;

              // Une los mensajes
              this.unirIndicesMensajesFalla(this.indexFalla, this.mensajeFalla);

              // Generar html para mostrar en la tabla de info
              let htmlListaMensajes = this.listaIndexMensajesFalla
                .map(
                  (elem) =>
                    `<tr><th scope="row" class="text-center">${elem.index +
                      2}</th><td>${elem.mensaje}</td></tr>`
                )
                .join("");

              // Abro modal con info
              Swal.fire({
                icon: "info",
                title: "Bajas",
                html:
                  `<h5>Códigos procesados exitosamente: ${this.codigosExitosos}</h5>` +
                  `<h5>Códigos no procesados: ${this.codigosFallidos}</h5>` +
                  `<table class="${
                    this.codigosFallidos ? "" : "d-none"
                  } table table-striped table-sm mt-3">
                  <thead>
                    <tr>
                      <th scope="col" class="text-center"># línea en csv</th>
                      <th scope="col">Error encontrado</th>
                    </tr>
                  </thead>
                  <tbody>
                    ${htmlListaMensajes}
                  </tbody>
                </table>`,
                confirmButtonText: "Cerrar",
              })
                // Cuando se clickea en boton cerrar, se limpian las variables
                .then((result) => {
                  if (result.isConfirmed) {
                    this.archivoBaja = null;
                    this.codigosExitosos = null;
                    this.codigosFallidos = null;
                    this.indexFalla = [];
                    this.mensajeFalla = [];
                    this.listaIndexMensajesFalla = [];

                    this.$refs.fileInputBaja.value = null;

                    // Cerrar modal y recargar tabla principal
                    this.$refs.modal.cerrar();
                    this.recargar();
                  }
                });
            })
            // Si ocurre un error en la request
            .catch(() => {
              Swal.fire(
                "Error",
                "Hubo un error al guardar el archivo",
                "error"
              );
            });
        }
        // Si es otro tipo de archivo que no sea csv
        else {
          Swal.fire(
            "Error",
            "Tipo de archivo inválido. Se espera archivo .csv",
            "error"
          )
            // Cuando se presiona en boton de confirmacion se limpia el input
            .then((result) => {
              if (result.isConfirmed) {
                this.$refs.fileInputBaja.value = null;
              }
            });
        }
      }
    },

    /**
     * Une los indices del error con el mensaje
     * @param {*} indices del error que trae la request
     * @param {*} mensajes de error que trae la request
     */
    unirIndicesMensajesFalla(indices, mensajes) {
      if (indices.length === mensajes.length) {
        indices.forEach((elt, i) => {
          this.listaIndexMensajesFalla.push({
            index: elt,
            mensaje: mensajes[i],
          });
        });
      }
    },

    // ---------- Metodos privados -----------
    cargar(busqueda = this.busqueda) {
      //Parámetros de paginación
      let desde = this.$refs.paginacion.Desde;
      let hasta = this.$refs.paginacion.Hasta;

      // Si es posible que se ordene en un futuro, se piden elementos extras
      if (this.puedeOrdenar) {
        // Pedir un elemento de la página anterior
        if (this.HayPaginaAnterior) desde--;
        // Pedir un elemento de la pagina siguiente
        if (this.HayPaginaSiguiente) hasta++;
      }

      this.facade
        .getListUsaCodigosWithFilter({
          desde,
          hasta,
          busqueda
        })
        .then((response) => {
          let datos = response.data;

          // Si se pidieron items extras para trabajar con orden
          // Tener en cuenta que el arreglo datos será modificado
          if (this.puedeOrdenar) {
            this.recortarDatosDeOrden(datos);
          }

          this.lista = datos;
          this.cargando = false;
        });
    },

    paginaCambiada(numero) {
      this.pagina = numero;
      this.cargar();
      // Scrollear al principio de la tabla
      Util.scrollearAId("tablaCodigos", true);
    },
    recargar(busqueda = this.busqueda) {
      this.cargando = true;
      this.pagina = 1;
      this.lista = [];
      
      this.facade.countUsaCodigosWithFilter({busqueda}).then((respuesta) => {
        this.cantidad = respuesta.data;

        if (this.cantidad > 0) this.cargar(busqueda);
        else this.cargando = false;
      });
    },
  },
  mounted() {
    if (!this.cargaManual) this.recargar();
  },
};
</script>

<style lang="scss" scoped>
@mixin contenido-tabla-codigos {
  th,
  td {
    padding: 0px 8px;
  }
}

.modal-detalle-codigos {
  .modal-dialog {
    padding-left: 0px;
    .container-tabla-codigos {
      overflow: auto;
      height: 80vh;
      .fila {
        th,
        td {
          vertical-align: middle;
        }
      }
    }
  }

  @media screen and (max-width: 991px) {
    margin-left: auto;
    margin-right: auto;
    .modal-dialog {
      max-width: 90vw;
      margin-left: auto;
      margin-right: auto;
      .container-tabla-codigos .fila {
        @include contenido-tabla-codigos;
      }
    }
  }
}

.tabla-beneficios .fila {
  th,
  td {
    vertical-align: middle;
  }
}

.teletransportador .titulo {
  font-size: 18px;
}

@media screen and (max-width: 991px) {
  .tabla-beneficios .fila {
    @include contenido-tabla-codigos;
  }
}
</style>
